import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import { Plus, Settings2, Trash2, X, Zap } from "lucide-react";
import { toast } from "sonner";
import { useChannel } from "@/lib/channel";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const errText = (e) => { const d = e.response?.data?.detail; return Array.isArray(d) ? "Başlık ve metin boş olamaz" : d || "İşlem başarısız"; };
let cache = null;

function QuickRepliesModal({ items, onClose, onSaved }) {
  const [rows, setRows] = useState(items.map((x) => ({ ...x }))), [busy, setBusy] = useState(false);
  const set = (i, k) => (e) => setRows(rows.map((r, j) => (j === i ? { ...r, [k]: e.target.value } : r)));
  const save = async (e) => {
    e.preventDefault(); e.stopPropagation(); setBusy(true);
    try { const r = await axios.put(`${API}/quick-replies`, { items: rows }); toast.success("Hazır cevaplar kaydedildi"); onSaved(r.data); }
    catch (err) { toast.error(errText(err)); setBusy(false); }
  };
  return createPortal(
    <div className="modal-backdrop" onClick={onClose}>
      <form className="modal wide" onSubmit={save} onClick={(e) => e.stopPropagation()} data-testid="quick-replies-modal">
        <div className="modal-head"><div><span className="eyebrow">MESAJLAR</span><h2>Hazır cevaplar</h2></div><button type="button" className="icon-btn" onClick={onClose} data-testid="quick-replies-close"><X /></button></div>
        <p className="form-hint">Metne <b>{"{ad}"}</b> yazarsanız oraya kişinin adı, <b>{"{kanal}"}</b> yazarsanız WhatsApp kanal linkiniz (Ayarlar → Ofis bilgileri) gelir. Tıklayınca metin mesaj kutusuna yazılır, düzenleyip gönderirsiniz.</p>
        <div className="qr-rows">
          {rows.map((r, i) => (
            <div className="qr-row" key={i} data-testid={`quick-reply-row-${i}`}>
              <input required maxLength={40} value={r.title} onChange={set(i, "title")} placeholder="Başlık" data-testid={`quick-reply-title-${i}`} />
              <textarea required maxLength={1000} rows={2} value={r.text} onChange={set(i, "text")} placeholder="Mesaj metni" data-testid={`quick-reply-text-${i}`} />
              <button type="button" className="icon-btn danger" onClick={() => setRows(rows.filter((_, j) => j !== i))} title="Sil" data-testid={`quick-reply-delete-${i}`}><Trash2 size={14} /></button>
            </div>
          ))}
          {rows.length === 0 && <p className="empty">Henüz hazır cevap yok.</p>}
        </div>
        <div className="modal-actions">
          <button type="button" className="outline-btn" disabled={rows.length >= 30} onClick={() => setRows([...rows, { title: "", text: "" }])} data-testid="quick-reply-add"><Plus size={14} />Yeni hazır cevap</button>
          <button className="primary-btn" disabled={busy} data-testid="quick-replies-save">{busy ? "Kaydediliyor…" : "Kaydet"}</button>
        </div>
      </form>
    </div>,
    document.body
  );
}

export function QuickReplies({ name, onPick }) {
  const [items, setItems] = useState(cache), [edit, setEdit] = useState(false);
  useEffect(() => { if (!cache) axios.get(`${API}/quick-replies`).then((r) => { cache = r.data; setItems(r.data); }).catch(() => setItems([])); }, []);
  const channel = useChannel();
  const first = (name || "").trim().split(/\s+/)[0];
  const fill = (t) => { t = t.replaceAll("{kanal}", channel); return first ? t.replaceAll("{ad}", first) : t.replace(/\s*\{ad\}/g, ""); };
  return (
    <div className="quick-replies" data-testid="quick-replies">
      <Zap size={14} className="qr-icon" />
      {(items || []).map((q, i) => (channel || !q.text.includes("{kanal}")) && <button type="button" key={i} className="qr-chip" title={fill(q.text)} onClick={() => onPick(fill(q.text))} data-testid={`quick-reply-${i}`}>{q.title}</button>)}
      <button type="button" className="qr-edit" disabled={!items} onClick={() => setEdit(true)} data-testid="quick-replies-edit"><Settings2 size={13} />Düzenle</button>
      {edit && <QuickRepliesModal items={items || []} onClose={() => setEdit(false)} onSaved={(x) => { cache = x; setItems(x); setEdit(false); }} />}
    </div>
  );
}
